import * as React from 'react';
import { useDispatch } from 'react-redux';
import { TDispatch } from '../../../../redux';
import { loadPublishTerms } from '../../../../redux/reducers';
import { PublishTermsError } from './PublishTermsError';

export const PublishTermsErrorContainer = () => {
  const dispatch = useDispatch<TDispatch>();

  const handleRetryClick = React.useCallback(() => {
    dispatch(loadPublishTerms());
  }, [dispatch]);

  return <PublishTermsError handleRetryClick={handleRetryClick} />;
};
